import { useAuth } from '../hooks/useAuth';
import { useTranslation } from 'react-i18next';
import TileGrid from '../components/layout/TileGrid';

export default function HomePage() {
  const { t } = useTranslation();
  const { user } = useAuth();

  return (
    <div className="px-4 py-6 max-w-4xl mx-auto">
      <h1 className="text-2xl font-bold text-gray-800 mb-1">
        {t('home.welcome', { name: user?.name })}
      </h1>
      <p className="text-gray-500 mb-6">{t('home.selectApp')}</p>
      <TileGrid />
    </div>
  );
}
